import React, { useMemo } from 'react';
import { EditForm } from './lineItem/EditForm';
import { IFeeEditLayout } from './lineItem/IFeeEditLayout';
import { useGetCurrentLineItem } from './useGetCurrentLineItem';
import { createDefaultSettlementItemForm } from 'types/order/fees/ICreateSettlementItemForm';
import { ISectionDefinitionData } from 'types/order/fees/ISectionDefinition';
import { ISectionData } from 'types/order/fees/ISectionData';

export interface IEditContainerProps extends IFeeEditLayout {
  sectionDefinition: ISectionDefinitionData;
  section?: ISectionData;
  lineItemId?: string;
  orderId: string;
}

export const EditContainer: React.FC<IEditContainerProps> = ({
  layout,
  sectionDefinition,
  lineItemId,
  orderId,
  section,
}) => {
  const lineItem = useGetCurrentLineItem({
    orderId,
    sectionDefinitionId: sectionDefinition.statementSectionDefinitionId,
    lineItemId,
  });
  const lineItemForm = useMemo(
    () => createDefaultSettlementItemForm(section?.statementSectionId, lineItem),
    [section?.statementSectionId, lineItem]
  );

  return (
    <EditForm layout={layout} lineItemForm={lineItemForm} section={section} sectionDefinition={sectionDefinition} />
  );
};
